import React, { useEffect, useMemo, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import useNavProject from '../../../hooks/useNavProject';
import useAPI from '../../../hooks/useAPI';
import Page from '../../../components/_layout/Page';
import WidgetsGrid from '../../../components/_layout/WidgetsGrid';
import useUserContext from '../../../hooks/useUserContext';
import { hasPermsOnIndexesOrReceipts } from '../../../services/rolesSvc';

function PortfolioWidgets() {
  const {
    stratId, portfolioId, projId, reportYear,
  } = useParams();

  const navProject = useNavProject();
  const api = useAPI();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [proj, setProj] = useState(null);
  const userCtx = useUserContext()

  const routes = useMemo(() => [
    { name: 'Реестр отчетов', url: `/strats/${stratId}/portfolios/${portfolioId}/report/reports` },
    { name: 'Статьи', url: `/strats/${stratId}/portfolios/${portfolioId}/report/articles` },
    { name: 'Доходы (не действует с 2023 года)', url: `/strats/${stratId}/portfolios/${portfolioId}/report/incomes`, inactive: true },
    { name: 'Заявки', url: `/strats/${stratId}/portfolios/${portfolioId}/report/requests` },
    { name: 'Унифицированные показатели проектов портфеля', url: `/strats/${stratId}/portfolios/${portfolioId}/report/unified`, show: () => hasPermsOnIndexesOrReceipts(userCtx, {stratId, portfolioId}) },
    { name: 'Вехи портфеля', url: `/strats/${stratId}/portfolios/${portfolioId}/report/milestones`},
    { name: 'Поступления от научной и иновационной деятельности', url: `/strats/${stratId}/portfolios/${portfolioId}/report/receipts` },
  ], [userCtx, stratId, portfolioId]);

  useEffect(() => {
    const fetchData = async () => {
      await getProj(projId);
    };
    fetchData();
  }, [projId]);

  const getProj = async (id) => {
    await setLoading(true);
    if (id) {
      const resProj = await api.get(`/projs/${id}?readonly=true`);
      if (resProj.error) {
        setError(resProj.error);
        setLoading(false);
        return;
      }

      navProject.setStratTitle(resProj.strategy.name);
      navProject.setPortfolioTitle(resProj.portfolio.name);
      navProject.setPortfProjTitle(resProj.name);

      setProj({
        ...resProj,
        startDate: resProj.startDate ? resProj.startDate.substring(0, 10) : undefined,
        endDate: resProj.endDate ? resProj.endDate.substring(0, 10) : undefined,
        approvedOn: resProj.approvedOn ? resProj.approvedOn.substring(0, 10) : undefined,
      });
    } else {
      const resStrat = await api.get('/mng/strategies?short=true');
      const strategyName = proj?.strategyId ? resStrat.find((s) => s.id === parseInt(proj.strategyId)).name : '';

      navProject.setProjTitle('Новый проект');
      navProject.setStratTitle(strategyName);

      setProj({
        ...proj,
        strategyName,
      });
    }
    await setLoading(false);
  };

  return (
    <Page header="Отчет по портфелю" className="policies-page">
      <WidgetsGrid items={routes.filter((w) => !w.show || w.show(userCtx.perms)) } />
    </Page>
  );
}

export default PortfolioWidgets;
